/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';
import { CallToAction, RichText } from '..';
import { graphql } from 'gatsby';

export default function TextBlock({ _rawText, callToAction }) {
  return (
    <Box>
      <RichText>{_rawText}</RichText>
      <CallToAction {...callToAction} />
    </Box>
  );
}

export const fragment = graphql`
  fragment SanityTextBlockFragment on SanityTextBlock {
    _rawText
    callToAction {
      ...CallToAction
    }
  }
`;
